export default __webpack_public_path__ + "static/media/follow.a1f5a070.svg";